export default __webpack_public_path__ + "static/media/UNMISS_firewood_patrol.29567186.jpg";